import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import Sidebar from "@/components/Sidebar";

export default function AppLayout({ user, onLogout }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const isAdmin = (user?.roles || []).includes("admin");
  const canExport = (user?.roles || []).some((r) => r === "admin" || r === "chef");
  const ctx = { user, isAdmin, canExport };

  return (
    <div className="h-screen w-full flex overflow-hidden bg-[#0B0F17] text-[#F8FAFC]">
      {/* Desktop sidebar */}
      <div className="hidden md:flex h-full">
        <Sidebar user={user} onLogout={onLogout} collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
      </div>

      <div className="flex-1 flex flex-col min-w-0">
        {/* Mobile top bar */}
        <div className="md:hidden flex items-center gap-2 h-12 px-3 border-b border-[#2A364F] bg-[#0B0F17] shrink-0">
          <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
            <SheetTrigger asChild>
              <button data-testid="mobile-menu-button" className="text-slate-300 p-1"><Menu className="h-5 w-5" /></button>
            </SheetTrigger>
            <SheetContent side="left" className="p-0 w-[260px] bg-[#0B0F17] border-[#2A364F]">
              <SheetTitle className="sr-only">Menu de navegação</SheetTitle>
              <Sidebar user={user} onLogout={onLogout} collapsed={false} onNavigate={() => setMobileOpen(false)} />
            </SheetContent>
          </Sheet>
          <span className="font-semibold text-sm">FAWKES ATLAS</span>
        </div>

        <main className="flex-1 min-h-0 overflow-hidden">
          <Outlet context={ctx} />
        </main>
      </div>
    </div>
  );
}
